module.exports = __webpack_public_path__ + "2e0d30f3e57996f0d3dc5e7e4a4f5de1.png";